export function trackQuestionAnswered(questionKey, answer) {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'SurveySignupModalSurveyQuestionAnswered',
    data: {
      questionKey,
      answer,
    },
  });
}

export function trackBackButtonClicked(questionKey) {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'SurveySignupModalBackButtonClicked',
    data: {
      questionKey,
    },
  });
}

export function trackIntroductionGetStartedClicked() {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'SurveySignupModalIntroductionGetStartedClicked',
  });
}
